import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import TransactionStatusPlate from "../../../TransactionStatusPlate";

import { GridTransaction } from "../../../../types";

interface Props extends ICellRendererParams {
  data: GridTransaction;
}

export const StatusRenderer = (props: Props) => (
  <TransactionStatusPlate {...props.data} />
);

export default StatusRenderer;
